<script>
import { mapState } from 'vuex'
import List from './List.vue'

export default {
    /*
    |--------------------------------------------------------------------------
    | Component > extends
    |--------------------------------------------------------------------------
    */
    extends: List, // End of Component > extends

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapState({
            isIndustrial: (state) => state.registration.isIndustrial,
        }),
    }, // End of Component > computed

    /*
    |--------------------------------------------------------------------------
    | Component > watch
    |--------------------------------------------------------------------------
    */
    watch: {
        isIndustrial(value) {
            this.$set(this.field, 'isDisabled', !value)
        },
    }, // End of Component > watch
}
</script>
